const ObserverDirective = {
  mounted(el, binding, vnode) {
    const observer = binding.value;
    console.debug("-> Will observe", el);
    observer.observe(el);
  },
  unmounted(el, binding, vnode) {
    const observer = binding.value;
    observer.unobserve(el);
  }
};


export default {
  install: function install(app) {
    app.directive('observer', ObserverDirective);
  }
}
